define("shared/errors/api-authorization-error", ["exports", "@ember/error"], function (_exports, _error) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/error"eaimeta@70e063a35619d71f
  /*
    Pattern from https://stackoverflow.com/questions/32456187/how-to-create-custom-error-classes-in-ember
   */
  function ApiAuthorizationError(error) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'You cannot view this resource';
    _error.default.call(this, message);
    this.errors = [error] || [{
      title: 'API Authorization Error',
      detail: message
    }];
  }
  ApiAuthorizationError.prototype = Object.create(_error.default.prototype);
  var _default = _exports.default = ApiAuthorizationError;
});